import { format, isLastDayOfMonth } from "date-fns";

interface Month {
  key: string;
  days: number;
}

function Month(date: Date, days: number): Month {
  return { key: format(date, "yyyy-MM"), days };
}

export default function getDaysInEachMonth(dates: Date[]): Month[] {
  const m: Month[] = [];
  const c = dates.reduce<number>((days, d) => {
    if (isLastDayOfMonth(d)) {
      m.push(Month(d, days + 1));
      return 0;
    } else {
      return days + 1;
    }
  }, 0);
  if (c > 0) {
    const d = dates.slice(-1)[0];
    m.push(Month(d, c));
  }
  return m;
}
